import * as moment from "moment";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import { GetFreeTimeCalendarEvents } from "./FreeHourNumbers/FreeTime/GetFreeTimes";

export function GetCalendarEventsCombinedWithFreeTimeEvents(
    eventData: ICalendarEvent[]
) {
    const freeTimeCalendarEvents = GetFreeTimeCalendarEvents(eventData);
    const combinedCalendarEvents = [...eventData, ...freeTimeCalendarEvents];

    const sortedCalendarEvents = combinedCalendarEvents.sort((a, b) =>
        moment(a.start).diff(b.start)
    );

    return sortedCalendarEvents;
}
